<div [formGroup]="parentForm">
    <div class="input-group">
        <input type="text" (click)="d.toggle()" [minDate]="{year: 1900, month: 1, day: 1}" [maxDate]="minDate" placeholder="dd/mm/aaaa" formControlName="{{controlName}}" class="form-control" name="dp" ngbDatepicker #d="ngbDatepicker" required>
        <div class="input-group-append">
            <button id="calendar" class="btn btn-outline-secondary" (click)="d.toggle()" type="button">
                <img style="filter: brightness(0) invert(1);" src="{{s3UrlImage}}Profile_Images/calendar.svg">
            </button>
        </div>
    </div>
</div>